module.exports = __webpack_public_path__ + "static/media/Pechugas de Pollo con Aderezo de Mayonesa.fe279833.webp";